<template>
  <HpAnchor
    class="action-link"
    :class="{ '!flex-col': stacked }"
    v-if="isCompared"
    @click.prevent="removePlan"
    :id="`remove-compared-plan-${medicareId}`"
  >
    <HpIcon
      :name="muted ? 'bookmark-filled-circle' : 'bookmark-filled'"
      :class="[
        { 'mr-1 w-fit': muted },
        { 'size-10 rounded-full border border-border bg-white p-1.5': stacked }
      ]"
    />
    <span :class="['hidden xs:flex', { 'text-sm font-semibold text-primary-700': muted }]">{{
      minimal ? 'Compared' : 'Added to Compare'
    }}</span>
    <span class="flex xs:hidden">Compared</span>
  </HpAnchor>
  <HpAnchor
    v-else
    class="action-link"
    :class="{ '!flex-col': stacked }"
    @click.prevent="addPlan"
    :id="`compare-plan-${medicareId}`"
  >
    <HpIcon
      :name="muted ? 'bookmark-empty-circle' : 'bookmark'"
      :class="[
        { 'mr-1 w-fit': muted },
        { 'size-10 rounded-full border border-border bg-white p-1.5': stacked }
      ]"
    />
    <span :class="['hidden xs:flex', { 'text-sm font-semibold text-gray-800': muted }]">{{
      minimal ? 'Compare' : 'Add to Compare'
    }}</span>
    <span class="flex xs:hidden">Compare</span>
  </HpAnchor>
</template>

<script lang="ts" setup>
  import { SessionStore } from '~/stores/session'

  const props = defineProps<{
    medicareId: string
    eventData: (() => Record<string, any>) | Record<string, any> | null | undefined
    minimal?: boolean
    stacked?: boolean
    muted?: boolean
  }>()

  const session = SessionStore.use()

  const isCompared = computed(() => session.comparedPlans.includes(props.medicareId))

  const addPlan = () => {
    session.comparedPlans.push(props.medicareId)
    // SessionStore.save()
  }

  const removePlan = () => {
    session.comparedPlans = _without(session.comparedPlans, props.medicareId)
    // SessionStore.save()
  }
</script>

<style scoped></style>

<style>
  input[type='checkbox'] {
    cursor: pointer;
  }
</style>
